import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  background: rgba(6,6,6,0.5);
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  z-index: 90;
  
  span {
    font-weight: bold;
    font-size: 14px;
    margin: 20px 0;
  }

  .confirm-window {
    background: var(--background_4);
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: var(--radius);
    padding: 12px 12px 24px 12px;
    width: 300px;
    min-height: 160px;
    position: absolute;
    top: 250px;
    z-index: 99;
  }

  .flex-end {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }

  .close-icon {
    cursor: pointer;
  }

  .icon-holder {    
    font-size: 60px;
    margin: 5px 0px 5px 0px;
  }

  .onclick-div {
    position: absolute;
    width: 100%;
    height: 100%;
  }
`;